import styles from './style.module.scss';
import { src } from '../../../utils/common';
import { WebPNativeImage } from '../../WebPImage';

const CurShowCard = ({ isCurPlay, item }) => {
  return (
    <div className={styles['show-item']} style={{ opacity: isCurPlay ? 1 : 0 }}>
      {/* 左侧图片: */}
      <WebPNativeImage src={src(item.picUrl)} className={styles['item-pic']} />
      {/* 右侧描述: */}
      <div className={styles['item-desc']}>
        <div className={styles['item-desc-title']}>{item.title}</div>
        <div className={styles['item-subtitle']}>{item.subTitle}</div>
      </div>
    </div>
  );
};

export default CurShowCard;
